module.exports = __webpack_public_path__ + "img/cuff_width.6d7a6d29.png";